/**
 * Lightweight session cache for list/table API payloads.
 * Speeds up revisit of the same list; network still refreshes in background.
 */
const PREFIX = 'panel_list_v1:'
const DEFAULT_TTL = 5 * 60 * 1000 // 5 minutes

function storage() {
  try {
    return window.sessionStorage
  } catch (e) {
    return null
  }
}

export function cacheKey(...parts) {
  return parts.map((p) => String(p == null ? '' : p)).join('|')
}

export function cacheGet(key) {
  const s = storage()
  if (!s || !key) return null
  try {
    const raw = s.getItem(PREFIX + key)
    if (!raw) return null
    const parsed = JSON.parse(raw)
    if (!parsed || typeof parsed !== 'object') return null
    if (parsed.exp && Date.now() > parsed.exp) {
      s.removeItem(PREFIX + key)
      return null
    }
    return parsed.data
  } catch (e) {
    return null
  }
}

export function cacheSet(key, data, ttlMs = DEFAULT_TTL) {
  const s = storage()
  if (!s || !key) return
  try {
    s.setItem(PREFIX + key, JSON.stringify({
      exp: Date.now() + (ttlMs || DEFAULT_TTL),
      data,
    }))
  } catch (e) {
    // quota / private mode — ignore
  }
}

export function cacheDel(key) {
  const s = storage()
  if (!s || !key) return
  try {
    s.removeItem(PREFIX + key)
  } catch (e) { /* ignore */ }
}

/** Invalidate all list cache entries whose key starts with prefix */
export function cacheDelPrefix(prefix) {
  const s = storage()
  if (!s) return
  try {
    const full = PREFIX + prefix
    const toRemove = []
    for (let i = 0; i < s.length; i++) {
      const k = s.key(i)
      if (k && k.startsWith(full)) toRemove.push(k)
    }
    toRemove.forEach((k) => s.removeItem(k))
  } catch (e) { /* ignore */ }
}
